import React, { useEffect, useRef, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import _ from "lodash";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { commonServices } from "../../../../api/services/commonServices";
import moment from "moment";
import {
  setLeaveCalendarData,
  setLeaveCalendarLoader,
} from "../../../../infra/aggregates/myProfile/leavesAggregates/leaveCalendarSlice";

const DTOLeaveCalendarData = (prop) => {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  const getLeaveCalendarData = () => {
    dispatch(setLeaveCalendarLoader(true));

    const getCurrentMonth = moment().get("month");
    const getCurrentYear = moment().get("year");
    const _currentMonth = getCurrentMonth + 1;
    commonServices
      .getCalendarData(
        selector.authSlice.company_id,
        selector.authSlice.emp_id,
        _currentMonth,
        getCurrentYear
      )
      .then((response) => {
        if (response?.data?.leaves) {
          dispatch(setLeaveCalendarData(response?.data?.leaves));
          prop.setAllLeaveCalendarData(response?.data?.leaves);
          dispatch(setLeaveCalendarLoader(false));
        }
      })
      .catch((err) => {
        dispatch(setLeaveCalendarLoader(false));
        console.log(err);
      });
  };
  useEffect(() => {
    getLeaveCalendarData();
  }, []);

  return <></>;
};

export default DTOLeaveCalendarData;
